var base = require('base/components/clientSideValidation');
var nifHelper = require('../utilities/nifHelper');
const { filterEmoji } = require('../utilities/stringUtils');

/**
 * Clean any emoji char from an input text or textarea
 * @param {jQuery|Element} input - The form control to clean
 * @returns {void}
 */
function cleanEmojiFromInput(input) {
    var inputElement = input instanceof jQuery ? input.get(0) : input;
    var shouldCleanEmoji = inputElement.matches('textarea,input[type="text"]');
    if (shouldCleanEmoji) {
        inputElement.value = filterEmoji(inputElement.value);
    }
}

/**
 * Validate form controls (input, textarea, select) and call valid/invalid actions
 * @param {HTMLElement} formControl element
 */
function validateFormControl(formControl) {
    if (!formControl) {
        return;
    }

    const isInvalid = !formControl.validity?.valid;
    if (isInvalid) {
        $(formControl).trigger('invalid', formControl.validity);
        $(formControl).closest('.form-group').removeClass('is-valid');
        $(formControl).closest('form')?.attr('data-valid', false);
        return;
    }

    // Custom billingAdNif validation
    if (formControl.id === 'billingAdNif'
        && !nifHelper.isValidNif(formControl.value)
    ) {
        var validationMessage = $(formControl).data('pattern-mismatch');
        $(formControl).parents('.form-group').find('.invalid-feedback')
            .text(validationMessage);
        $(formControl).closest('.form-group').removeClass('is-valid');
        $(formControl).closest('form')?.attr('data-valid', false);
        return;
    }

    const hasValue = formControl.value && formControl.value !== '';
    if (hasValue) {
        $(formControl).closest('.form-group').addClass('is-valid');
        $(formControl).closest('form')?.attr('data-valid', true);
    }
}

/**
 * @onforyou same function as in helpers/emailHelpers.js
 *
 *  Checks if the email value entered is correct format
 * @param {string} email - email to validate
 * @return {boolean} - Whether email is valid
 */
function validateEmail(email) {
    var regex = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
    return regex.test(email);
}

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
    var valid = true;
    if (this.checkValidity && !this.checkValidity()) {
        // safari
        valid = false;
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
        $(this).find('input, select, textarea').each(function () {
            cleanEmojiFromInput(this);
            validateFormControl(this);
        });
    }
    return valid;
}

module.exports = {
    invalid: function () {
        $('form input, form select, form textarea').on('invalid', function (e) {
            e.preventDefault();
            this.setCustomValidity('');
            if (!this.validity.valid) {
                var validationMessage = this.validationMessage;
                $(this).addClass('is-invalid');
                if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
                    validationMessage = $(this).data('pattern-mismatch');
                }
                if ((this.validity.rangeOverflow || this.validity.rangeUnderflow)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if ((this.validity.tooLong || this.validity.tooShort)
                    && $(this).data('range-error')) {
                    validationMessage = $(this).data('range-error');
                }
                if (this.validity.valueMissing && $(this).data('missing-error')) {
                    validationMessage = $(this).data('missing-error');
                }
                $(this).parents('.form-group').find('.invalid-feedback')
                    .text(validationMessage);
            }
        });
    },
    submit: base.submit,
    buttonClick: base.buttonClick,
    formControlFocusOut: function () {
        $(document).on('focusout', '.form-control', function () {
            cleanEmojiFromInput(this);
            validateFormControl(this);
        });
    },
    functions: {
        validateForm: function (form, event) {
            validateForm.call($(form), event || null);
        },
        clearForm: base.clearForm,
        validateEmail: validateEmail
    }
};
